(function (core) {
    'use strict';
    var trigger = Onicon.trigger,
        protocol = Onicon.protocol,
        dom = Onicon.lib('dom'),
        $ = Onicon.$;

    var timer = {
        secToTimer: function (sec) {
            var fillzero = function (num) {
                    return num < 10 ? "0" + num : num
                },
                days = Math.floor(sec / 86400),
                hours = Math.floor((sec - (days * 86400)) / 3600),
                minutes = Math.floor((sec - (days * 86400) - (hours * 3600)) / 60),
                seconds = Math.floor(sec - (days * 86400) - (hours * 3600) - (minutes * 60));
            return [
                days,
                fillzero(hours),
                fillzero(minutes),
                fillzero(seconds)
            ];
        },

        declOfNum: function (number, titles) {
            var cases = [2, 0, 1, 1, 1, 2];
            // Дальше будет вложеный тернарник, просто закройте глаза и идите дальше.
            return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
        },

        create: function (elem, date) {
            setInterval(function () {
                var now = new Date(),
                    to = date,
                    diff = (to - now) / 1e3;
                if (now.getTime() < to) {
                    var sections = dom.elementChildren(elem);
                    for (var s = 0; s < sections.length; s++) {
                        var container = sections[s],
                            desc = container.getElementsByTagName('ins')[0],
                            holder = container.getElementsByTagName('span')[0],
                            num = timer.secToTimer(diff)[s];
                        holder.innerHTML = num;
                        switch (s) {
                            case 0:
                                var titles = ['день', 'дня', 'дней'];
                                break;
                            case 1:
                                var titles = ['час', 'часа', 'часов'];
                                break;
                            case 2:
                                var titles = ['минута', 'минут', 'минут'];
                                break;
                            case 3:
                                var titles = ['секунда', 'секунды', 'секунд'];
                                break;
                        }
                        desc.innerHTML = timer.declOfNum(parseInt(num), titles);
                    }
                }
            }, 1000);
        }
    };

    var widgets = {
        widgets_html: '',

        init: function () {
            trigger.bind('panel_created', function () {
                if (core.current_state == core.STATE_OFFLINE) {
                    // Для начала, в любом случае заполняем поле для виджетов стандартными полями для обратной совместимости
                    widgets.name = core.site_info.default_widget_set ? core.site_info.default_widget_set : '__not__set__';
                    Onicon.log('[widgets] Default Widget Set: ', widgets.name);
                    widgets.showWidgets(true);
                }
            });

            trigger.bind(trigger.EV_PACKET, function (packet) {
                if (packet.flag == protocol.SERVER_CODE_SHOW_WIDGET) {
                    widgets.autosend_id = packet.sas_id;
                    widgets.name = packet.name ? packet.name : '__not__set__';
                    widgets.text = packet.text;

                    if (packet.name=='callback') {
                        widgets.showCallback(packet.text);
                    } else {
                        widgets.showWidgets();
                    }
                }
            });
        },

        setDefault: function (widget_set) {
            // Global Default Widget Set
            Onicon.log('[widget] Show Default Widget Set', widget_set);
            switch (widget_set) {
                case 'callback':
                    return [
                        {
                            enabled: true,
                            type: 'bigtext',
                            text: 'Мы перезвоним вам в течение нескольких минут!'
                        },
                        {
                            enabled: true,
                            type: 'input',
                            title: 'Номер телефона'
                        },
                        {
                            enabled: true,
                            type: 'submit',
                            style_class: 'callback-button',
                            title: 'Отправить'
                        }
                    ];
                    break;
                case 'sample-timer':
                    return [
                        {
                            enabled: true,
                            type: 'panel_title',
                            text: 'Успей до конца акции!!!'
                        },
                        {
                            enabled: true,
                            type: 'image',
                            url: '/uploads/sale.png'
                        },
                        {
                            enabled: true,
                            type: 'timer',
                            text: "До конца акции осталось:",
                            till: (new Date).getTime() + 2e7
                        },
                        {
                            enabled: true,
                            type: 'bigtext',
                            text: 'Чтобы получить скидку, оставьте Ваши контакты!'
                        },
                        {
                            enabled: true,
                            type: 'input',
                            title: 'Ваше имя'
                        },
                        {
                            enabled: true,
                            type: 'input',
                            title: 'Ваши контакты'
                        },
                        {
                            enabled: true,
                            type: 'submit',
                            title: 'Хочу скидку'
                        }
                    ];
                    break;
                case 'sample-action':
                    return [{
                        "type": "panel_title",
                        "text": "Есть вопросы? Задавайте!",
                        "enabled": true
                    }, {
                        "type": "textarea",
                        "enabled": true,
                        "title": "Что Вас интересует?",
                        "validate": "required"
                    }, {
                        "type": "input",
                        "enabled": true,
                        "title": "Ваши контакты:",
                        "validate": "required"
                    }, {
                        "type": "submit",
                        "enabled": true,
                        "title": "Отправить"
                    }, {
                        "type": "bigtext",
                        "enabled": true,
                        "text": "<br>Товар дня по суперцене!<br>Жидкокристаллический телевизор"
                    }, {
                        "type": "image",
                        "enabled": true,
                        "url": "/uploads/tv.png"
                    }, {
                        "type": "discount",
                        "enabled": true,
                        "old_price": "40000",
                        "new_price": "35999 руб."
                    }];
                    break;
                case 'sample-standart':
                case 'undefined':
                default:
                    return [
                        {
                            enabled: true,
                            type: 'panel_title',
                            text: 'Оставьте нам сообщение'
                        },
                        {
                            enabled: true,
                            type: 'autosend-message'
                        },
                        {
                            enabled: true,
                            type: 'input',
                            title: 'Ваше имя'
                        },
                        {
                            enabled: true,
                            type: 'input',
                            title: 'Ваш e-mail',
                            validate: 'email'
                        },
                        {
                            enabled: true,
                            type: 'input',
                            title: 'Ваш номер телефона',
                            validate: 'phone'
                        },
                        {
                            enabled: true,
                            type: 'textarea',
                            title: 'Сообщение'
                        },
                        {
                            enabled: true,
                            type: 'submit',
                            title: 'Отправить'
                        }
                    ];
                    break;
            }
        },

        showWidget: function (widget, text, no_hide) {
            no_hide = no_hide ? no_hide : false;
            widgets.name = widget;
            widgets.text = text ? text : 'Оставьте нам сообещение!';
            Onicon.log('[widgets] Show Widget ' + widget + ', Text: ' + text);
            widgets.showWidgets(true);
            core.setPanelHeight();
            if (!no_hide) {
                dom.addClass(core.getById('bookmark'), 'onicon_chat-hint-wrap_is-hidden');
                core.hideBlock('float_button_wrap');
                core.showPanel();
            }
        },

        showCallback: function (text) {
            if(Onicon.LOADER_PARAMS.wix && Wix != undefined) {
                Wix.resizeWindow(500, 400);
            }

            //if (core.viewCallbackButton) {
                Onicon.log('[widgets] Show Callback');
                trigger.execute('sas_disable');
                widgets.name = 'callback';
                dom.addClass(core.getById('bookmark'), 'onicon_chat-hint-wrap_is-hidden');
                core.hideBlock('float_button_wrap');
                widgets.showCallbackForm();


                $('.onicon-modal-window .onicon_chat-form-field input').intlTelInput({
                    autoFormat: true,
                    initialCountry: 'auto',
                    preferredCountries: ['ru', 'by', 'ua', 'kz'],
                    onlyCountries: ['ru', 'by', 'ua', 'kz', 'uz', 'de', 'gb', 'us', 'az', 'ge', 'tr', 'md', 'lt', 'lv', 'es'],
                    geoIpLookup: function(callback) {
                        var current = core.region.split(','),
                            code = 'ru';
                        for(var i in core.countryList) {
                            if(core.countryList[i] != undefined && core.countryList[i].toLowerCase() == current[0].toLowerCase()) {
                                code = i;
                            }
                        }
                        callback(code);
                    },
                    customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
                        if(selectedCountryData.iso2 == 'ru') return '7 (XXX) 123-45-67';
                        else if(selectedCountryData.iso2 == 'kz') return '8(XXX) XXX XXXX';
			            else if(selectedCountryData.iso2 == 'by') return '+375 (XX) 123-45-67';
                        else if(selectedCountryData.iso2 == 'th') return '+66 (XX) XXX-XX-XX';
                        else return selectedCountryPlaceholder;
                    }
                });

                if (text) {
                    Onicon.$('.onicon_chat-promo-heading').text(text);
                }

            //}
        },

        callbackBindEvents: function() {
            if (core.getById('send-callback-button')) {
                dom.attachEvent('click', function () {
                    var v_phone = $(".onicon-modal-window .onicon_chat-form-field input"), rule;
                    if (v_phone.intlTelInput("isValidNumber")) {
                        Onicon.lib('validator').mark_field(v_phone[0], true);
                        $(".onicon-modal-loading").fadeIn();
                    } else {
                        Onicon.lib('validator').mark_field(v_phone[0]);
                        return;
                    }

                    var phone = v_phone.intlTelInput("getNumber", Onicon.phoneUtils.numberFormat.E164);

                    trigger.execute('callback-click', {
                        phone: phone
                    });

                    if ([
                            "megagroup.ru",
                            "onicon.ru",
                            "xn----8sbg1acauhcdqcjfjcgj.xn--p1ai"
                        ].indexOf(location.host) != -1) {
                        rule = 45660;
                    } else {
                        rule = 679;
                    }

                    if (core.canCallback) {
                        Onicon.rpc.call({
                            ctrl: "vox",
                            action: "makeCall",
                            type: "POST",
                            params: {
                                "tPhone": phone.replace("+", ""),
                                "rule": 679,
                                "text": core.site_info.callback.welcome_text
                            },
                            success: function (data) {
                                Onicon.core.processVoxCallback(data);
                            }
                        });
                    } else {
                        $.ajax({
                            url: Onicon.URL_STATIC + '/index.php?mode=main&act=offline',
                            type: "POST",
                            crossDomain: true,
                            data: {
                                userId: core.user_id,
                                userHash: core.user_hash,
                                formData: [{
                                    type: 'input',
                                    title: 'Номер телефона',
                                    validation: 'required',
                                    result: phone
                                }],
                                replyTo: 'Виджет обратной связи',
                                replyForm: core.getById('drag').getElementsByTagName('strong')[0].innerHTML,
                                hostname: location.hostname,
                                clientPhone: 1,
                                contacts: core.site_info.callme.contacts
                            },
                            success: function (responce) {
                                Onicon.core.processCallbackMessage(responce);
                            }
                        });
                    }

                }, core.getById('send-callback-button'));


                // dom.attachEvent('click', function () {
                //     window.ONICON_OFFLINE_SEND && window.ONICON_OFFLINE_SEND.call();

                //     var v_phone = $(".onicon-modal-window .onicon_chat-form-field input"), rule;

                //     if (v_phone.intlTelInput("isValidNumber")) {
                //         Onicon.lib('validator').mark_field(v_phone[0], true);
                //         $(".onicon-modal-loading").fadeIn();
                //     } else {
                //         Onicon.lib('validator').mark_field(v_phone[0]);
                //         return;
                //     }

                //     var phone = v_phone.intlTelInput("getNumber", Onicon.phoneUtils.numberFormat.E164)

                //     if ([
                //             "megagroup.ru",
                //             "onicon.ru",
                //             "xn----8sbg1acauhcdqcjfjcgj.xn--p1ai"
                //         ].indexOf(location.host) != -1) {
                //         rule = 45660;
                //     } else {
                //         rule = 679;
                //     }

                //     if (core.canCallback) {
                //         Onicon.rpc.call({
                //             ctrl: "vox",
                //             action: "makeCall",
                //             type: "POST",
                //             params: {
                //                 "tPhone": phone.replace("+", ""),
                //                 "rule": rule,
                //                 "text": core.site_info.callback.welcome_text
                //             }
                //         }).always(function(data){
                //             // No data required
                //             Onicon.core.processCallbackMessage();
                //         })
                //     }

                //     $.ajax({
                //         url: Onicon.URL_STATIC + '/index.php?mode=main&act=offline',
                //         type: "POST",
                //         crossDomain: true,
                //         data: {
                //             user_id: core.user_id,
                //             user_hash: core.user_hash,
                //             formdata: [{
                //                 type: 'input',
                //                 title: 'Номер телефона',
                //                 validation: 'required',
                //                 result: phone
                //             }],
                //             reply_to: 'Виджет обратной связи',
                //             reply_form: core.getById('drag').getElementsByTagName('strong')[0].innerHTML,
                //             hostname: location.hostname,
                //             client_phone: 1,
                //             contacts: core.site_info.callme.contacts
                //         },
                //         success: function (responce) {
                //             Onicon.core.processCallbackMessage(responce);
                //         }
                //     });

                // }, core.getById('send-callback-button'));
            } else {
                Onicon.log('Callback Send Button Not Found!');
            }
        },

        showCallbackForm: function(type) {
            //Показывать затемнение только если это не викс
            if(!Onicon.LOADER_PARAMS.wix) {
                var fog = $('<div>')
                    .attr('id', core.createId('onicon-fog'))
                    .addClass('fog-hidden')
                    .css({
                        display: 'none',
                        background: 'rgba(0,0,0,0.8)',
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        'zIndex': 10000
                    });

                $('body').append(fog);
                fog.fadeIn('slow');
            }

            var bigtext = '',
                field_title = '',
                button_text = '';

            if(core.site_info.callme) {
                bigtext = core.site_info.callme.bigtext || '',
                field_title = core.site_info.callme.field_title || '',
                button_text = core.site_info.callme.button_text || '';
            }

            if(core.canCallback) {
                bigtext = core.site_info.callback.bigtext || '';
                field_title = core.site_info.callback.field_title || '';
                button_text = core.site_info.callback.button_text || '';
            }

            var modal = $(core._createId('modal-window'));

            if (modal.length == 0) {
                var copyright = '';
                var termsText = '';
                var termsType = Onicon.core.site_info.terms_of_use;
                var termsUrl = Onicon.core.site_info.terms_of_use_link;
                var termsChat = Onicon.core.site_info.terms_of_use_chat;
                var termsForms = Onicon.core.site_info.terms_of_use_forms;
                var locale = Onicon.core.locale;

                if (!core.no_copyright) {
                    copyright = '<div class="onicon_chat-title">'+Onicon.core.locale.footer+'</div></div>';
                }

                if (['onicon', 'site'].indexOf(termsType) !== -1) {
                    var agreeText = locale.terms_of_use_agree.replace('{{url}}', termsType === 'site' ? termsUrl : 'https://onicon.ru/terms-of-use');
                    termsText = '<label class="button-submit__label"><input type="checkbox" class="button-submit__checkbox" id="'+core.createId('agree-checkbox')+'">' + agreeText + '</label>';
                }

                var modal = $('<div>')
                    .attr('id', core.createId('modal-window'))
                    .css({'background-color': 'rgb(235, 235, 235);'})
                    .addClass('onicon-modal-window onicon_chat-animation modal-hidden')
                    .html('<div class="onicon-modal-loading" id="' + core.createId('modal-loading') + '"><img src="https://cp.onicon.ru/images/admin/onicon-loader-load_.gif" alt=""></div>' +
                    '<div class="onicon-modal-header" id="' + core.createId('modal-header') + '">' +
                    '<span class="onicon-modal-close" title="Close" id="' + core.createId('modal-hide-button') + '">+</span></div>' +
                    '<div class="onicon-modal-content onicon_chat-content" id="' + core.createId('modal-content') + '">' +
                        '<div class="onicon_chat-form-row " type="bigtext">' +
                            '<div class="onicon_chat-promo-heading" style="color:' + core.site_info.callback_color + '">' + bigtext + '</div>' +
                        '</div>' +
                        '<div class="onicon_chat-form-row " type="input">' +
                        '<label for="field-text">' + field_title + '</label>' +
                            '<div class="onicon_chat-form-field">' +
                                '<input type="text" />' +
                            '</div>' +
                        '</div>' +
                        '<div class="onicon_chat-form-row"> ' + termsText +
                            '<button type="submit" id="' + core.createId('send-callback-button') + '" class="onicon_chat-s3-btn callback-button" style="background-color:' + core.site_info.callback_color + '">' + button_text + '</button> ' +
                            '<button class="onicon_chat-s3-btn onicon_chat-close-btn" id="' + core.createId('widget-close') + '">Закрыть</button> ' +
                        '</div>' +
                    '</div>' +
                    '<div class="system-message" id="' + core.createId('system-message-call') + '" style="display:none">Сообщение отправлено!</div>' +
                    '<div class="onicon_chat-form-row onicon_chat-form-copyrights">' + copyright);


                $('body').append(modal);

                if (termsText) {
                  $(core.getById('send-callback-button'))
                    .attr('disabled', true)
                    .css('opacity', 0.2)

                  $(core.getById('agree-checkbox')).change(function (event) {
                    var checkedAgree = $(this).prop('checked');
                    $(core.getById('send-callback-button'))
                    .attr('disabled', !checkedAgree)
                    .css('opacity', checkedAgree ? 1 : 0.2)
                  })
                }

                widgets.callbackBindEvents();

                setTimeout(function(){
                    modal.removeClass('modal-hidden');
                }, 200);

                core.getById('modal-hide-button').onclick = function () {
                    Onicon.core.showBookmark();
                    if (!Onicon.navigator.isMobile) {
                        trigger.execute('sas_enable');
                    }
                    core._getById('modal-window').addClass('modal-hidden');

                    core._getById('onicon-fog').fadeOut('slow',function(){
                        Onicon.core._getById('onicon-fog').remove();
                    })
                };
            } else {
                core._getById('modal-window').removeClass('modal-hidden');
            }

        },

        showWidgets: function (first_run, type) {
            var popup = core.getById('widget-area'),
                container = type ? type : core.site_info.online_widget_pos;

            if (!popup) {
                var popup = document.createElement('div');
                popup.setAttribute('style', 'padding: 10px; background-color: #EBEBEB;');
                popup.id = core.createId("widget-area");

            }

            switch (container) {
                case 'modal':

                    var fog = $('<div>')
                        .attr('id', core.createId('onicon-fog'))
                        .addClass('fog-hidden')
                        .css({
                            display: 'none',
                            background: 'rgba(0,0,0,0.8)',
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            'zIndex': 10000
                        });

                    $('body').append(fog);
                    fog.fadeIn('slow');

                    var modal = $(core._createId('modal-window'));
                    if (modal.length == 0) {
                        var copyright = '';
                        if (!core.no_copyright) {
                            copyright = '<div class="onicon_chat-title">' + (core.no_copyright ? '&nbsp;' : core.locale.footer_call) + '</div></div>';
                        }

                        var modal = $('<div>')
                            .attr('id', core.createId('modal-window'))
                            .css({'background-color': 'rgb(235, 235, 235);'})
                            .addClass('onicon-modal-window onicon_chat-animation modal-hidden')
                            .html('<span class="onicon-modal-close" title="Close" id="' + core.createId('modal-hide-button') + '">+</span>' +
                            '<div class="onicon-modal-loading" id="' + core.createId('modal-loading') + '"><img src="https://cp.onicon.ru/images/admin/onicon-loader-load_.gif" alt=""></div>' +
                            '<div class="onicon-modal-header" id="' + core.createId('modal-header') + '"> ' +
                            '</div>' +
                            '<div class="onicon-modal-content onicon_chat-content" id="' + core.createId('modal-content') + '"></div>' +
                            '<div class="system-message" id="' + core.createId('system-message-call') + '" style="display:none">Сообщение отправлено!</div>' +
                            '<div class="onicon_chat-form-row onicon_chat-form-copyrights">' + copyright);

                        $('body').append(modal);

                        setTimeout(function(){
                            modal.removeClass('modal-hidden');
                        }, 200);

                        core.getById('modal-hide-button').onclick = function () {
                            Onicon.core.showBookmark();
                            if (!Onicon.navigator.isMobile) {
                                trigger.execute('sas_enable');
                            }
                            core._getById('modal-window').addClass('modal-hidden');

                            core._getById('onicon-fog').fadeOut('slow',function(){
                                Onicon.core._getById('onicon-fog').remove();
                            })
                        };

                    } else {
                        core._getById('modal-window').removeClass('modal-hidden');
                    }

                    break;
                case 'down':
                    core.getById('panel').insertBefore(popup, core.getById('panel').children[4]);
                    break;
                case 'up':
                default:
                    core.getById('panel').insertBefore(popup, core.getById('panel').children[1]);
                    break;
            }

            dom.addClass(popup, 'onicon_chat-body onicon_chat-offline-form');

            // В независимости от режима modal pos отображается в отдельном окне
            // Сетим контейнер виджета в зависимости от режима online/offline
            if (container == 'modal') {
                var widget_container = core.getById('modal-content');
            } else {
                var widget_container = core.getById('offline-form');
                if (core.current_state == core.STATE_ONLINE) {
                    widget_container = core.getById('widget-area');
                    core.showBlock('widget-area');
                }
            }

            var reply_to, widget_sets = core.site_info.widgets ? core.site_info.widgets : {},
                current_widget = widget_sets[widgets.name] ? widget_sets[widgets.name] : widgets.setDefault(widgets.name),
                html = widgets.generateWidgets(current_widget, core.site_info.colors, widgets.name);


            widget_container.innerHTML = widgets.name == 'callback' ? html.replace('send-offline-button', 'send-callback-button') : html;


            var $termsOfUse = $('.onicon_chat-terms-of-use input');
            var submitId = core.createId('send-offline-button');
            var $submitId = $('#' + submitId);

            if ($termsOfUse.get(0)) {
                $termsOfUse.on('change', function() {
                    var $this = $(this);
                    $submitId.prop('disabled', !$this.prop('checked'));
                }).trigger('change');
            }


            if (core.getById('send-callback-button')) {
                dom.attachEvent('click', function () {
                    var v_phone = $(".onicon-modal-window .onicon_chat-form-field input"), rule;

                    if (v_phone.intlTelInput("isValidNumber")) {
                        Onicon.lib('validator').mark_field(v_phone[0], true);
                        $(".onicon-modal-loading").fadeIn();
                    } else {
                        Onicon.lib('validator').mark_field(v_phone[0]);
                        return;
                    }

                    var phone = v_phone.intlTelInput("getNumber", Onicon.phoneUtils.numberFormat.E164);

                    trigger.execute('send-callback', {
                        phone: phone
                    });

                    if (core.site_info.vox_callback_enabled) {
                        Onicon.rpc.call({
                            ctrl: "vox",
                            action: "makeCall",
                            params: {
                                "tPhone": phone.replace("+", ""),
                                "rule": 679,
                                "text": core.site_info.callback.welcome_text
                            },
                            success: function (data) {
                                Onicon.core.processVoxCallback(data);
                            }
                        });
                    } else {
                        $.ajax({
                            url: Onicon.URL_STATIC + '/index.php?mode=main&act=offline',
                            type: "POST",
                            crossDomain: true,
                            data: {
                                userId: core.user_id,
                                userHash: core.user_hash,
                                formData: [{
                                    type: 'input',
                                    title: 'Номер телефона',
                                    validation: 'required',
                                    result: phone
                                }],
                                replyTo: 'Виджет обратной связи',
                                replyForm: core.getById('drag').getElementsByTagName('strong')[0].innerHTML,
                                hostname: location.hostname,
                                clientPhone: 1
                            },
                            success: function (responce) {
                                Onicon.core.processCallbackMessage(responce);
                            }
                        });
                    }

                }, core.getById('send-callback-button'));
            } else {
                Onicon.log('Callback Send Button Not Found!');
            }

            if (core.getById('send-offline-button')) {
                dom.attachEvent('click', function () {
                    // Первичная валидация полей
                    var elements = core.getById('offline-form').getElementsByClassName('onicon_chat-form-row');
                    if (core.current_state == core.STATE_ONLINE) {
                        elements = core.getById('widget-area').getElementsByClassName('onicon_chat-form-row');
                    }

                    var validation_flag = true;
                    for (var i = 0; i < elements.length; i++) {
                        var element = elements[i];
                        if (element.length) element = element[0];
                        var elem_type = element.getAttribute('type');
                        if (['input', 'textarea'].indexOf(elem_type) != -1) {
                            var control = element.getElementsByTagName(elem_type)[0];
                            var fields = [{
                                "input": element.getElementsByTagName(elem_type)[0],
                                "value": element.getElementsByTagName(elem_type)[0].value,
                                "method": control.getAttribute('validate')
                            }];

                            var val_result = Onicon.lib('validator').validate_fields(fields);
                            if (!val_result) {
                                validation_flag = false;
                            }
                        }
                    }

                    if (!validation_flag) {
                        return;
                    }

                    core.getById('system-message').innerHTML = core.locale.offline_form_sending;
                    core.showBlock('system-message');
                    this.disabled = true;

                    var formdata = core.offlineReader();

                    if (core.getById('widget-offline-header-msg')) {
                        reply_to = core.getById('widget-offline-header-msg').children[0].innerText;
                    } else {
                        reply_to = core.getById('offline-title').children[0].innerText
                    }

                    $.ajax({
                        url: Onicon.URL_STATIC + '/index.php?mode=main&act=offline',
                        type: "POST",
                        crossDomain: true,
                        data: {
                            userId: core.user_id,
                            userHash: core.user_hash,
                            formData: formdata,
                            replyTo: reply_to,
                            replyForm: core.getById('drag').getElementsByTagName('strong')[0].innerHTML,
                            hostname: location.hostname,
                            contacts: core.site_info.widget_contacts
                        },
                        cache: false,
                        success: function (responce) {
                            Onicon.core.processOfflineMessage(responce);
                        }
                    });

                    trigger.execute('offlineForm-click', formdata);

                    core.getById('widget-area').style.display = "none";
                }, core.getById('send-offline-button'));
            } else {
                Onicon.log('Send Button Not Found!');
            }

            if (core.isolated) {
                core.getById('control-close').onclick = core.closeWindow;
            } else {
                core.getById('control-close').onclick = core.switchPanels;
            }

            // PowerUP Widgets
            var timer_children = dom.getElementsByAttribute('timer-data');
            for (var i = 0; i < timer_children.length; i++) {
                var t = timer_children[i];
                var now = new Date().getTime();
                var to_date = t.getAttribute("timer-data");
                if (now < to_date) {
                    timer.create(t, t.getAttribute("timer-data"))
                }
            }

            if (widgets.autosend_id) {
                // Последний раз пересчитываем высоту панели
                // С небольшой задержкой т.к. высота высчитывается
                // на основании того что будет сгенерировано
                setTimeout(function () {
                    core.setPanelHeight();
                    if (!first_run) {
                        core.showPanel();
                        Onicon.core.systemMessage(Onicon.core.locale.msg_operators_state_changed_to_online, 'operators-state');
                    }
                    if (widgets.text && core.getById('widget-offline-header-msg')) {
                        core.getById('widget-offline-header-msg').getElementsByClassName('onicon_chat-message-text')[0].innerHTML = widgets.text;
                    }
                }, 100);

            }

            if (core.getById('widget-close')) {
                core.getById('widget-close').onclick = function () {
                    core.hideBlock('widget-area');
                }
            }
        },

        generateWidgets: function (site_widgets, colors, widget_name) {
            widgets.widgets_html = '';
            //for (var w_index in site_widgets) {
            for(var g = 0; g < site_widgets.length; g++) {
                var widget_data = site_widgets[g];
                Onicon.log('[widgets] Generate: ' + widget_data.type);
                var _class = widget_data.style_class ? widget_data.style_class : '';

                if (core.current_state == core.STATE_ONLINE && widget_name != 'callback') {
                    var _hide = 'style="display:none"';
                } else {
                    var _hide = '';
                }

                if (!widget_data.id) {
                    widget_data.id = Math.random().toString(36).substr(2, 34);
                }

                if (widget_data.enabled) {
                    switch (widget_data.type) {
                        // Cистемные поля, не выпиливать
                        case 'autosend-message':
                            widget_data['text'] = widget_data.text ? widget_data.text : 'Если у Вас возникли вопросы, оставьте, пожалуйста, сообщение. Мы обязательно свяжемся с Вами!';
                            var widget_html = '<div class="onicon_chat-form-row ' + _class + '" type="' + widget_data.type + '" id="' + core.createId('widget-' + widget_data.id) + '"> \
                                                   <div class="onicon_chat-message onicon_chat-sendTypeOperator" id="' + core.createId('widget-offline-header-msg') + '" style="background-color:' + colors[1] + ';"> \
                                                       <div class="onicon_chat-message-text">' + Onicon.formatter.format(widget_data.text) + '</div> \
                                                   </div> \
                                               </div>';
                            break;
                        // Конец системных полей
                        case 'input':
                            var widget_html = '<div class="onicon_chat-form-row ' + _class + '" type="' + widget_data.type + '" id="' + core.createId('widget-' + widget_data.id) + '" ' + _hide + '> \
                                                   <label for="field-text">' + widget_data.title + '</label> \
                                                   <div class="onicon_chat-form-field"> \
                                                       <input type="text" value="" validate="' + widget_data.validate + '"> \
                                                   </div> \
                                               </div> ';
                            //if(widget_name == 'callback') {
                            //    widget_html = widget_html + '<div class="onicon_chat-form-row"><div class="onicon-phone-helper">Например +79161234567</div></div>';
                            //}
                            break;
                        case 'textarea':
                            var widget_html = '<div class="onicon_chat-form-row ' + _class + '" type="' + widget_data.type + '" id="' + core.createId('widget-' + widget_data.id) + '" ' + _hide + '> \
                                                   <label for="field-textarea">' + widget_data.title + '</label> \
                                                   <div class="onicon_chat-form-field"> \
                                                       <textarea cols="30" rows="2" style="height: 50px;" validate="' + widget_data.validate + '"></textarea> \
                                                   </div> \
                                               </div>';
                            break;
                        case 'submit':

                            var terms_of_use = '';

                            if (core.site_info.terms_of_use && core.site_info.terms_of_use !== 'none') {
                                terms_of_use = '<label class="onicon_chat-terms-of-use"><input type="checkbox" /> ';
                                var link = (core.site_info.terms_of_use === 'onicon' ? 'https://onicon.ru/terms-of-use' : core.site_info.terms_of_use_link);
                                terms_of_use += core.locale.terms_of_use_agree.replace('{{url}}', link);
                                terms_of_use+= '</label>';
                            }

                            var widget_html = '<div class="onicon_chat-form-row" type="' + widget_data.type + '" id="' + core.createId('widget-' + widget_data.id) + '"> \
                                                   ' + terms_of_use + '\
                                                   <button type="submit" id="' + core.createId('send-offline-button') + '" class="onicon_chat-s3-btn ' + _class + '" style="background-color: ' + colors[0] + ';">' + widget_data.title + '</button> \
                                               <button class="onicon_chat-s3-btn onicon_chat-close-btn" id="' + core.createId('control-close') + '">' + core.locale.close + '</button>\
                                               </div>';
                            if (core.current_state == core.STATE_ONLINE) {
                                widget_html = '<div class="onicon_chat-form-row" type="' + widget_data.type + '" id="' + core.createId('widget-' + widget_data.id) + '" ' + _hide + '> \
                                                   ' + terms_of_use + '\
                                                   <button type="submit" id="' + core.createId('send-offline-button') + '" class="onicon_chat-s3-btn ' + _class + '" style="background-color: ' + colors[0] + ';">' + widget_data.title + '</button> \
                                               <button class="onicon_chat-s3-btn onicon_chat-close-btn" id="' + core.createId('widget-close') + '">' + core.locale.close + '</button>\
                                               </div>';
                            }
                            break;
                        case 'image':
                            var widget_html = '<div class="onicon_chat-form-row ' + _class + '" type="' + widget_data.type + '" id="' + core.createId('widget-' + widget_data.id) + '"> \
                                                   <img src="' + Onicon.URL_STATIC + widget_data.url + '" alt=""> \
                                               </div>';
                            break;
                        case 'timer':
                            var widget_html = '<div class="onicon_chat-form-row ' + _class + '" type="' + widget_data.type + '" id="' + core.createId('widget-' + widget_data.id) + '"> \
                                                   <div class="onicon_chat-promo-subheading"> \
                                                       ' + widget_data.text + ' \
                                                   </div> \
                                                   <div class="onicon_chat-promo-counter" timer-data="' + widget_data.till + '"> \
                                                       <div class="onicon_chat-promo-num red"> \
                                                           <span>00</span> \
                                                           <ins>день</ins> \
                                                       </div> \
                                                       <div class="onicon_chat-promo-num"> \
                                                           <span>00</span> \
                                                           <ins>часов</ins> \
                                                       </div> \
                                                       <div class="onicon_chat-promo-num"> \
                                                           <span>00</span> \
                                                           <ins>минут</ins> \
                                                       </div> \
                                                       <div class="onicon_chat-promo-num last"> \
                                                           <span>00</span> \
                                                           <ins>секунд</ins> \
                                                       </div> \
                                                   </div> \
                                               </div>';
                            break;
                        case 'discount':
                            var widget_html = '<div class="onicon_chat-form-row ' + _class + '" type="' + widget_data.type + '" id="' + core.createId('widget-' + widget_data.id) + '"> \
                                                   <div class="onicon_chat-promo-old-price">' + widget_data.old_price + '</div> \
                                                   <div class="onicon_chat-promo-new-price">' + widget_data.new_price + '</div> \
                                               </div>';
                            break;
                        case 'bigtext':
                            var widget_html = '<div class="onicon_chat-form-row ' + _class + '" type="' + widget_data.type + '" id="' + core.createId('widget-' + widget_data.id) + '"> \
	                                               <div class="onicon_chat-promo-heading" style="color:' + core.site_info.colors[0] + ';">' + widget_data.text + '</div> \
                                               </div>';
                            break;
                        case 'smalltext':
                            var widget_html = '<div class="onicon_chat-form-row ' + _class + '" type="' + widget_data.type + '" id="' + core.createId('widget-' + widget_data.id) + '"> \
	                                               <div class="onicon_chat-promo-paragraph">' + widget_data.text + '</div> \
                                               </div>';
                            break;
                        case 'panel_title':
                            Onicon.log('[widgets] Setting Panel Header: ', widget_data.text);
                            if (widget_name != 'callback') {
                                Onicon.core.setPanelHeader(widget_data.text);
                                //Onicon.core.setBookmarkText(widget_data.text);
                            }

                            var widget_html = '';
                            break;
                        default:
                            widget_html = '';
                            break;
                    }
                    widgets.widgets_html += widget_html;
                }
            }
            return widgets.widgets_html;
        }
    };

    Onicon.lib('widgets', widgets, true);
    Onicon.lib('timer', timer, true);
})(Onicon.core);
